import CheckIcon from "@mui/icons-material/Check";
import React, { memo, useEffect, useRef } from "react";

import "./Toast.scss";

interface IToastProps {
	message: string;
	onHide: () => void;
}

const Toast: React.FC<IToastProps> = ({ message, onHide }) => {
	const timeoutRef = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		timeoutRef.current = setTimeout(onHide, 1500);

		return () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
		};
	}, [onHide]);

	return (
		<div className="ToastContainer">
			<div className="Toast">
				<div className="ToastContent">
					<div className="ToastIconWrapper">
						<CheckIcon className="ToastIcon" />
					</div>
					<span className="ToastMessage">{message}</span>
				</div>
			</div>
		</div>
	);
};

export default memo(Toast);
